import { Chart, ChartOptions } from 'chart.js';

export const options: ChartOptions<'doughnut'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'right',
      labels: {
        pointStyle: 'rect',
        usePointStyle: true,
        generateLabels: (chart) => {
          const original = Chart.overrides.doughnut.plugins.legend.labels.generateLabels(chart);
          return original.map((label) => ({
            ...label,
            text: label.text.length > 25 ? label.text.substring(0, 25) + '…' : label.text,
          }));
        },
      },
    },
  },
};
